import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import Register from "./Register";
import { beginFetchRegisterUser } from "../../sagas/register";

function mapState(state: any) {
  return {
    emailAddress: state.login.emailAddress
  };
}

function mapDispatch(dispatch: Dispatch) {
  return {
    registerUser: bindActionCreators(beginFetchRegisterUser, dispatch)
  };
}

export default connect(
  mapState,
  mapDispatch
)(Register);
